import {AjaxStatusCore, WebserviceCore} from "dts-react-common";
import config from "./Config";
import reduxStore from "./ReduxStore";
import {dispatchUpdateData} from "../misc/Shared";


export const ajaxStatusCore = new AjaxStatusCore();
const webserviceCore = new WebserviceCore({
	baseUrl: config.baseWebserviceUrl,
	ajaxStatusCore: ajaxStatusCore,
	jsLogging: undefined,
	loadDefaultsCallback: defaults => {
		let logoutTimer = reduxStore.getState().timer;
		if (logoutTimer) {
			clearTimeout(logoutTimer);
			logoutTimer = undefined;
		}
		logoutTimer = setTimeout(() => window.location = window.location.origin+'/', 30*60*1000);
		dispatchUpdateData({
			field: 'timer',
			value: logoutTimer,
		});

		const userToken = sessionStorage.getItem('userToken');
		defaults.headers.common['Authorization'] = userToken ? `Bearer `+ userToken : false;
		//defaults.headers.common['content-type'] = "application/json";
	},
});

export default {
	
	authentication: {
		authenticationRequest: (authenticationRequest) => webserviceCore.post('Authentication',authenticationRequest)
	},
	veteranStatus:{
		statusRequest:(statusRequest)=>webserviceCore.post('VeteranVerification/GetVeteranStatus',statusRequest,"searchRecord")
	}
};
